import { useRef, useState, useEffect } from 'react';

/**
 * A hook that returns a ref and dimensions of the element it is attached to.
 * @returns A tuple containing the ref and dimensions of the element.
 */
var useResize = function () {
  var ref = useRef(null);
  var _a = useState({
      width: 0,
      height: 0
    }),
    dimensions = _a[0],
    setDimensions = _a[1];
  useEffect(function () {
    var updateSize = function () {
      if (ref.current) {
        setDimensions({
          width: ref.current.offsetWidth,
          height: ref.current.offsetHeight
        });
      }
    };
    var timeoutId;
    var handleResize = function () {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(updateSize, 180);
    };
    window.addEventListener('resize', handleResize);
    updateSize();
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, [ref]);
  return [ref, dimensions];
};

export { useResize };
//# sourceMappingURL=useResize.js.map
